<template>
<div class="progress" :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: ['size'],
    computed: {
        _class: function() {
            let _class= []

            if(this.size) {
                _class.push('progress-'+this.size)
            }

            return _class
        }
    }
}
</script>